import React from "react";
import { Link } from "react-router-dom";
import { Grid } from "./Grid";
import { batchActions } from "redux-batched-actions";
import {
  Container,
  Topbar,
  Right,
  SidebarContainer,
  LeftList,
  LeftListItem
} from "./Base";
import { Tree } from "./Sidebar";
// import { PivotTable } from "./Pivot";
import { Pivot, InnerPivot } from "./data";
import { BoardChart } from "./data2";
import { inputArray } from "./input";
import { ReportTable } from "./Table"; //, ReportSelectTable
import Chart from "./Chart";
import { Responsive, WidthProvider } from "react-grid-layout";
import { ReportsLayout } from "./GridLayout";
import _ from "lodash";
import Preloader from './Preloader';
import { findPaths } from '../lib/helpers';
const ResponsiveReactGridLayout = WidthProvider(Responsive);

// class Layout extends Component {
//   render() {
//     const { board } = this.props;
//     const layout = board.layout;
//     const reports = board.reportSet.all().toModelArray();
//     return (
//       <ResponsiveReactGridLayout
//         {...layout.ref}
//         onLayoutChange={(lay, lays) =>
//           this.props.layout_upsert({ id: layout.id, ...lays })}
//       >
//         {reports.map((report, index) => (
//           <div key={index} style={{ overflow: "auto" }}>
//             {report.data ? (
//               <BoardChart definition="Demo" report={report} {...this.props} />
//             ) : (
//               ""
//             )}
//           </div>
//         ))}
//       </ResponsiveReactGridLayout>
//     );
//   }
// }

function generateDOM() {
  return _.map(_.range(5), function (i) {
    return (
      <div key={i}>
        <span className="text">{i}</span>
      </div>
    );
  });
}

// <WrappedComponent {...this.props} {...WrappedComponentProps} />;

// export const Dashboard = () => <div>{"Deneme"}</div>;
// props.Session.RX_Folder.filter(folder => (folder.name = "Root")).first()
const fillFolder = (props, module) => ({
  module: module,
  files: props.Session.RX_Board.filter(board =>
    module.boards.includes(board.id.toString())
  )
    .toModelArray()
    .map(board => fillNode(props, board)),
  folders: props.Session.RX_Folder.filter(folder =>
    module.children.includes(folder.id.toString())
  )
    .toModelArray()
    .map(folder => fillFolder(props, folder))
});

const fillNode = (props, module) => ({
  module: module
});

class Sidebar extends React.Component {
  render() {
    let tree = fillFolder(
      this.props,
      this.props.Session.RX_Folder.filter(
        folder => folder.name === "Root"
      ).first()
    );
    return (
      <SidebarContainer>
        <LeftList style={{ flexGrow: 1 }}>
          <Tree {...this.props} tree={tree} />
        </LeftList>
        {this.props.Session.RX_Board.filter(
          item => item.type === "Settings" && item.status === "Active"
        ).exists() && (
            <LeftList>
              <Link to={"/settings"}>
                <LeftListItem>
                  <span style={{ width: "25px" }} className={`fa fa-cogs`} />
                  {"Settings"}
                </LeftListItem>
              </Link>
            </LeftList>
          )}
      </SidebarContainer>
    );
  }
}

const getBoard = (props, name) => {
  const fullPath = findPaths(props, props.match.params.name);
  return props.task_request({
    action: "getBoard",
    payload: {
      name,
      logType: 'report',
      fullPath,
      url: window.location.href
    },
    success: result => {
      return batchActions([
        props.batch.upsert({
          model: "RX_Board",
          payload: {
            ...result,
            reports: result.reports.map(report => report.id)
          }
        }),
        ...result.reports.map(report =>
          props.batch.upsert({
            model: "RX_Report",
            payload: {
              ...report,
              filterdata: Object.assign({}, report.config.filterdata)
            }
          })
        )
      ]);
    }
  })
}

export class Dashboard extends React.Component {
  constructor(props) {
    super(props);
    const currentUrl = props.match.params.name;
    if (this.props.Session.RX_Board.filter({ url: currentUrl }).exists()) {
      const name = this.props.Session.RX_Board.filter({
        url: currentUrl
      }).first().name;
      getBoard(this.props, name);
    }
  }
  componentWillReceiveProps(nextProps) {
    const currentUrl = this.props.match.params.name;
    const nextUrl = nextProps.match.params.name;
    if (
      currentUrl !== nextUrl &&
      this.props.Session.RX_Board.filter({ url: nextUrl }).exists()
    ) {
      const id = this.props.Session.RX_Board.filter({ url: nextUrl }).first()
        .id;
      //TODO: session yuklendikten sonra grid initselect cekmeli, burayı sonra kaldırabiliriz
      this.props.upsert({
        model: "RX_Board",
        payload: {
          reports: [],
          id: id
        }
      });
      if (this.props.Session.RX_Board.filter({ url: nextUrl }).exists()) {
        const name = this.props.Session.RX_Board.filter({
          url: nextUrl
        }).first().name;
        getBoard(this.props, name);
      }
    }
  }
  render() {
    const url = this.props.match.params.name;

    if (!this.props.Session.RX_Board.filter({ url: url }).exists()) {
      return <Preloader />;
    }
    let board = this.props.Session.RX_Board.filter({ url: url }).first();
    const reports = board.reports;
    let reportsAll = undefined;

    if (!reports) {
      return <Preloader />;
    } else {
      reportsAll = reports.map((reportId, index) =>
        this.props.Session.RX_Report.withId(reportId)
      );
    }

    let layout = undefined;
    if (board.viewtype === "ReportsBoard" && reportsAll.length > 0) {
      layout = (
        <ReportsLayout
          config={board.config}
          updateconfig={data =>
            this.props.upsert({
              model: "RX_Board",
              payload: {
                id: board.id,
                config: Object.assign({}, board.config, data)
              }
            })
          }
          reportProps={this.props}
          reports={reportsAll}
        />
      );
    } else if (board.viewtype === "Iframe" && reportsAll.length > 0) {
      layout = reportsAll.map((report, index) => {
        let url = report && report.config && report.config.queries && report.config.queries.browserselect && report.config.queries.browserselect.text;
        return <iframe key={index} width="100%" height="100%" src={url} frameBorder="0" style={{ border: 0 }} allowFullScreen />
      });
    } else {

      layout = reportsAll.map((report, index) => {
        if (
          report.config.type === "React-Table" ||
          report.config.type === "React-Select-Table"
        ) {
          return (
            <ReportTable
              key={index}
              {...this.props}
              config={report.config}
              updateconfig={data =>
                this.props.upsert({
                  model: "RX_Report",
                  payload: {
                    id: report.id,
                    config: Object.assign({}, report.config, data)
                  }
                })
              }
            />
          );
        } else if (report.config.type === "Pivot")
          // else if (report.config.type === "React-Select-Table")
          //   return (
          //     <ReportSelectTable
          //       key={index}
          //       {...this.props}
          //       config={report.config}
          //     />
          //   );
          return <Pivot key={index} id={report.id} {...this.props} />;
        else {
          // console.log(index)
          // console.log(report.id)
          // console.log(this.props)
          return <Grid key={index} id={report.id} {...this.props} />
        };
      });
    }

    return (
      <Container
        Rows={"40px auto"}
        Columns={"200px auto"}
        Areas={'"top top" "left right"'}
      >
        <Topbar {...this.props} Area={"top"} />
        <Sidebar Area={"left"} {...this.props} />
        <Right Area={"right"}>{layout}</Right>
      </Container>
    );
  }
}

// //
//                 <ResponsiveReactGridLayout
//                   layout={layout}
//                   onLayoutChange={function() {}}
//                   key={index}
//                 >
//                   <ReportTable key={1} {...this.props} config={report.config} />
//                   <ReportTable key={2} {...this.props} config={report.config} />
//                   <ReportTable key={3} {...this.props} config={report.config} />
//                   <ReportTable key={4} {...this.props} config={report.config} />
//                   <ReportTable key={5} {...this.props} config={report.config} />
//                 </ResponsiveReactGridLayout>

// //
//               <ResponsiveReactGridLayout
//                 layout={layout}
//                 onLayoutChange={function() {}}
//                 key={index}
//               >
//                 <ReportTable {...this.props} config={report.config} />
//               </ResponsiveReactGridLayout>;

// <BoardChart />
// <RTable />

// {inputArray.map(input => [
//   <InnerPivot {...input} />,
//   <Chart options={input.charts(input)} />
// ])}

// <InnerPivot {...growthActualYtd} />
// <BoardChart />
// {reports.map((reportId, index) => {
//   const report = this.props.Session.RX_Report.withId(reportId);
//   console.log("report: ", report);
//   if (report.config.type === "Pivot")
//     return <Pivot key={index} id={reportId} {...this.props} />;
//   else return <Grid key={index} id={reportId} {...this.props} />;
// })}



// WEBPACK FOOTER //
// ./src/components/Dashboard.js